import React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import { CheckCircle, Cancel } from '@mui/icons-material';
import { green, red, grey } from '@material-ui/core/colors';

type Props = {
  status: 'accepted' | 'rejected' | 'no-response';
};

const StatusIcon: React.FC<Props> = ({ status }) => {
  const isAccepted = status === 'accepted';
  const noResponse = status === 'no-response';

  return (
    <Tooltip title={isAccepted ? 'Accepted' : 'Rejected'}>
      <IconButton disabled sx={{ opacity: 0.5 }}>
        {isAccepted || noResponse ? (
          <CheckCircle
            style={{ color: noResponse ? grey[500] : green[500], fontSize: 45 }}
          />
        ) : (
          <Cancel style={{ color: red[500], fontSize: 45 }} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default StatusIcon;
